module.exports = __webpack_public_path__ + "static/media/Bird9.2cc4192b.jpg";